import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 148 146"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M109.15 5.544A5.547 5.547 0 0 0 103.6 0a5.547 5.547 0 0 0-5.55 5.544v7.393h-48.1V5.544A5.547 5.547 0 0 0 44.4 0a5.547 5.547 0 0 0-5.55 5.544v7.393H16.444C7.362 12.937 0 19.557 0 27.722v103.493C0 139.381 7.362 146 16.444 146h115.112c9.082 0 16.444-6.619 16.444-14.785V27.721c0-8.165-7.362-14.784-16.444-14.784H109.15zM16.444 24.025c-1.841 0-3.296.67-4.202 1.484-.888.798-1.142 1.595-1.142 2.212V59.14h125.8V27.721c0-.617-.255-1.414-1.142-2.212-.906-.815-2.361-1.484-4.202-1.484H109.15v3.697a5.547 5.547 0 0 1-5.55 5.544 5.547 5.547 0 0 1-5.55-5.544v-3.697h-48.1v3.697a5.547 5.547 0 0 1-5.55 5.544 5.547 5.547 0 0 1-5.55-5.544v-3.697z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }